<style scoped>
    .box{
        background: #000;
        height: 100vh;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    video{
        width: 80%;
        height: 90%;
    }
    .back{
      color: #fff;
      position: absolute;
      width: 100px;
      height: 30px;
      left: 20px;
      top: 20px;
    }
</style>
<template>
  <div class="box">
    <div class="back" @click="back">返回</div>
    <video name="media" muted src="https://cdn.ysqingxin.com/szhjz2.m4v" autoplay controls>

    </video>
  </div>
</template>
<script>
import { getSource, getSources } from "../api";
import noMoreData from "components/no-more-data";
import newsTopBox from "components/newsTopBox";
import topbar from "components/topbar";
import moment from "moment/moment";
import footerBox from "components/footer";
import { Swiper, Slide } from "vue-swiper-component";
import wx from "weixin-js-sdk";
import echarts from "echarts";
let components = {
  noMoreData,
  topbar,
  Swiper,
  Slide,
  footerBox,
  newsTopBox,
};
export default {
  data() {
    return {
      //                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
      EnvUrl: `https://cdn.ysqingxin.com/`,
    };
  },
  components: components,
  filters: {
    time(value) {
      let transTime = moment(value).format("YYYY-MM-DD HH:mm:ss");
      return transTime;
    },
  },
  computed: {},
  methods: {
    back(){
      history.back()
    },
    to(n) {
      // this.$router.push(`/informationDetail`)
    },
    async getScaleBannerList() {
      let data = await getSources(
        "/bear-scale/api/micro/getMicroBannerList.json",
        {}
      );
      if (data.status === 0) {
        this.microBannerList = data.microBannerList;
      } else {
        alert(data.msg);
      }
    },
    toNone() {
      const isZzd =
        JSON.stringify(navigator.userAgent).indexOf("TaurusApp") > -1;
      if (!isZzd) {
        location.href =
          "https://dgov-integrate.jinhua.gov.cn:5443/szjh-gov-pc/#/404";
      }
    },
  },
  destroyed() {

  },
  mounted() {
    localStorage.setItem("sp", true);
    document.title =
      "天台县社区矫正“一体式”心理矫治系统（阳光治矫）/杭州帅熊网络科技有限公司";
    this.toNone();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/video.vue?393df84e